<template>
	<m-main-layout>
		<div>
			<el-form :model="formData" :rules="rules" label-width="120px" ref="form">
				<el-form-item label="名称" prop="name">
					<el-input v-model="formData.name" style="width: 500px;" maxlength="6" show-word-limit></el-input>
				</el-form-item>
				<el-form-item label="菜单类型" prop="type">
					<type-select v-model="formData.type" @change="onChangeType" :options="[{id:'view',name:'网页'},{id:'miniprogram',name:'小程序'}]"></type-select>
				</el-form-item>
				<el-form-item label="链接url" prop="url" :rules="[{required:true,message:'链接url必填'}]">
					<el-input v-model="formData.url" style="width: 500px;" maxlength="50" show-word-limit></el-input>
				</el-form-item>
				<el-form-item label="小程序appId" prop="appid" v-if="formData.type === 'miniprogram'" :rules="[{required:true,message:'小程序appId必填'}]">
					<el-input v-model="formData.appid" style="width: 500px;" maxlength="50" show-word-limit></el-input>
				</el-form-item>
				<el-form-item label="小程序页面路径" prop="pagepath" v-if="formData.type === 'miniprogram'" :rules="[{required:true,message:'小程序页面路径必填'}]">
					<el-input v-model="formData.pagepath" style="width: 500px;" maxlength="50" show-word-limit></el-input>
				</el-form-item>
				<el-form-item label="排序" prop="sort">
					<el-input v-model="formData.sort" style="width: 500px;" maxlength="5" show-word-limit></el-input>排序数字越小越靠前
				</el-form-item>
				<el-form-item label="状态" prop="state">
					<el-switch
						v-model="formData.state"
						active-color="#13ce66"
						:active-value="1"
						:inactive-value="0"
						active-text="启用"
						inactive-text="禁用">
					</el-switch>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="toSubmit">保存</el-button>
					<el-button @click="$router.back()">返回</el-button>
				</el-form-item>
			</el-form>
		</div>
	</m-main-layout>
</template>

<script>
export default {
	name: "edit",
	data() {
		return {
			formData:{
				id:'',
				name:'',
				akey:'fuwu',
				type:'',
				url:'',
				sort:'',
				state:'',
				appid:'wx667cf49161d63c18',
				pagepath:'pages/index/index'
			},
			
			rules:{
				name:[{required:true,message:'菜单名称必填'}],
				type:[{required:true,message:'菜单类型必填'}],
				sort:[{required:true,message:'排序必填'}],
				state:[{required:true,message:'状态必填'}],
			}
		}
	},
	created() {
		this.formData.id = this.$route.query.id ? this.$route.query.id : '';
	},
	mounted() {
		if(this.formData.id){
			this.getDetail();
		}
	},
	methods: {
		onChangeType(e){
			if(e === 'view'){
				this.formData.appid = '';
				this.formData.pagepath = '';
			}
		},
		getDetail(){
			let _this = this;
			
			this.$http.httpPost({
				url:'/MenuWeixin/detail',
				datas:{id:this.formData.id},
				success:(res)=>{
					_this.formData.name = res.name;
					_this.formData.akey = res.akey;
					_this.formData.type = res.type;
					_this.formData.url = res.url;
					_this.formData.sort = res.sort;
					_this.formData.state = res.state;
					_this.formData.appid = res.appid;
					_this.formData.pagepath = res.pagepath;
				}
			});
		},
		toSubmit(){
			let _this = this;
			
			this.$refs['form'].validate((valid) => {
				if (valid) {
					let _url = '';
					
					if(_this.formData.id){
						_url = '/MenuWeixin/edit';
					}else{
						_url = '/MenuWeixin/add';
					}
					_this.$http.httpPost({
						url:_url,
						datas:_this.formData,
						success:(res)=>{
							_this.$message.success('保存成功');
							_this.$router.back();
						}
					});
				} else {
					console.log('error submit!!');
					return false;
				}
			});
		}
	}
}
</script>
